export default "__VITE_ASSET__BVPLrlsE__"